<template>
  <div class="flex flex-nowrap overflow-x-auto space-x-4 px-4 pb-4 pt-2">
    <draggable :list="items" class="flex flex-nowrap space-x-4" handle=".handle">
      <div
        v-for="slide in items"
        :key="slide.id"
        class="item box-border flex items-center flex-shrink-0 cursor-pointer space-x-1 rounded-3xl outline-solid-2"
        :class="{
          'outline-solid-purple-500': isActiveItem(slide),
        }"
        @click="$emit('click-item', slide)"
      >
        <div v-if="isEditMode" class="handle">
          <div class="w-6 h-6 flex items-center justify-center rounded-md bg-opacity-40">
            <Icon icon="ph:dots-six-vertical-bold" height="16" />
          </div>
        </div>

        <div class="flex items-center space-x-3">
          <div
            class="w-15 h-15 flex items-center justify-center flex-shrink-0 overflow-hidden"
          >
            <span
              v-if="slide.emoji"
              class="text-6xl leading-none"
            >
              {{ slide.emoji }}
            </span>
            <div v-else class="relative w-full h-full bg-gray-200 rounded-full" />
          </div>

          <p
            class="w-41 text-base leading-5 font-medium m-0"
            :class="{ 'opacity-30': !Boolean(slide.title) }"
          >
            {{ slide.title || 'Без заголовка' }}
          </p>
        </div>

        <div v-if="isEditMode" @click="$emit('delete-item', slide)">
          <div
            class="w-6 h-6 flex items-center justify-center rounded-md bg-opacity-40"
          >
            <Icon icon="ph:trash" height="16" class="text-red-500" />
          </div>
        </div>
      </div>
    </draggable>

    <div
      v-if="isEditMode"
      class="flex-shrink-0 w-15 h-15 flex items-center justify-center bg-gray-200 rounded-full cursor-pointer"
      @click="$emit('add')"
    >
      <Icon icon="ph:plus" width="24" class="text-gray-500" />
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { useMode } from '../composables/mode'
import { useActiveItem } from '../composables/items'

export default {
  components: { Draggable },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'view',
      validator: (val) => ['view', 'edit'].includes(val)
    },
    activeItem: {
      type: Object,
      default: null,
    }
  },
  setup(props) {
    const { isEditMode } = useMode(props)
    const { isActiveItem } = useActiveItem(props)

    return {
      isEditMode,
      isActiveItem,
    }
  }
}
</script>